import { Box, TextNew } from '@jfs/ui-new'
import { FunctionComponent } from 'react'
import { SelectParentEntityList } from '../EntityManagement/Onboarding/CreateEntity/SelectParentEntityList'

const columnFlexMapper: any = {
  0: 1,
  1: 1,
  2: 1.5,
  3: 0.5,
}
const headerTitles = [
  { title: 'Application ID' },
  { title: 'Checker Name' },
  { title: "Checker's Comment" },
  { title: 'Time Stamp' },
]
interface AuditTrailProps {
  data: any[]
}
const AuditTrail: FunctionComponent<AuditTrailProps> = ({ data }: AuditTrailProps) => {
  return (
    <Box flex={1} pv={32} ph={80}>
      <TextNew title="Audit Trail" />
      <SelectParentEntityList
        title={''}
        hide={false}
        data={data}
        headerTitles={headerTitles}
        columnFlexMapper={columnFlexMapper}
      />
    </Box>
  )
}

export { AuditTrail }
